import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Segment from '../../entities/tracing/segment'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface SegmentState extends ListState<Segment>{
    editModel: Segment;
}
class SegmentModule extends ListModule<SegmentState,any,Segment>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Segment>(),
        loading:false,
        editModel: new Segment(),
        activeList: new Array<Segment>(),
        path: 'segments'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
    });
}
const segmentModule=new SegmentModule();
export default segmentModule;
